import { ContextTypes } from "constant";
import { ActionTyped } from "reducers/IAction";
import { SelectContextAction, FetchContextSuccess } from "reducers/context.reducer";
import { ContextParam } from "interfaces/Home";

export type FetchContextAction = ActionTyped<ContextTypes.FETCH_CONTEXT>;

/**
 * Demande de récupération du contexte
 */
export function fetchContext(): FetchContextAction {
  return {
    type: ContextTypes.FETCH_CONTEXT,
    payload: undefined
  };
}

/**
 * Demande de récupération du contexte valide
 * @param contexts contexts récupéré
 */
export function fetchContextSuccess(contexts: ContextParam[]): FetchContextSuccess {
  return {
    type: ContextTypes.FETCH_CONTEXT_SUCCESS,
    payload: {
      contexts
    }
  };
}

/**
 * Demande de sélection du contexte
 * @param selected contexte sélectionné
 */
export function selectContext(selected: string): SelectContextAction {
  return {
    type: ContextTypes.SELECT_CONTEXT,
    payload: { selected }
  };
}
